import { Box, Button, Typography, Grid, ButtonBase } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material';

interface EventCreateButtonProps {
  onClick: () => void;
  isDisabled?: boolean;
}

const EventCreateButton: React.FC<EventCreateButtonProps> = ({
  onClick,
  isDisabled = false
}) => {
  const { t } = useTranslation();
  const theme = useTheme();

  if (isDisabled) {
    return (
      <ButtonBase
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          justifyContent: 'center',
          height: '100%',
          width: '100%',
          backgroundColor: theme.palette.text.disabled,
          borderColor: 'divider',
          borderRadius: 1,
          padding: theme.spacing(2),
          textAlign: 'center',
          cursor: 'default'
        }}
      >
        <Typography variant="body1">
          {t('join_team_to_create_events')}
        </Typography>
      </ButtonBase>
    );
  } else {
    return (
      <Grid
        container
        direction="column"
        alignItems="center"
        justifyContent="center"
        style={{ height: '100%' }}
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          sx={{
            width: '100%',
            height: '100%',
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 1
          }}
        >
          <Button
            variant="contained"
            color="primary"
            sx={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
              justifyContent: 'center',
              height: '100%',
              width: '100%',
              backgroundColor: theme.palette.text.disabled
            }}
            onClick={onClick}
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
            >
              <AddIcon fontSize="large" />
              <Typography
                variant="h6"
                sx={{ textAlign: 'center', marginTop: 1 }}
              >
                {t('add_event')}
              </Typography>
            </Box>
          </Button>
        </Box>
      </Grid>
    );
  }
};
export default EventCreateButton;
